import '../App.css';
import React from 'react';
import { write, useSnap } from '../store'
// import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import Listening from '../components/Listening'
import Writing from '../components/writing'
import Speaking from '../components/speaking'
import LoadingOverCard from './loadingOverCard'
// import { WsContext } from '../App'
import { pack } from 'msgpackr';
// import toast from 'react-hot-toast';
import NewModal from '../components/newModal';
import posthog from 'posthog-js';


const choices = ['A.', 'B.', 'C.', 'D.', 'E.', 'F.']

function SingleQ({ questionData, type }) {
    const contentRef = React.useRef()
    const read = useSnap()
    const [selected, setSelected] = React.useState();
    // const [fontSize, setFontSize] = React.useState();
    // const ws = React.useContext(WsContext);
    const ws = read.ws

    const handleAnswer = (e) => {
        if (!selected) {
            setSelected(e.target.value)
            write.stopTimer = true
            // write.answers.push(e.target.value) // we dont save the answers locally anymore
            setTimeout(() => {
                ws.send(pack({ type: 'ONE_ANSWER', id : read.id , data: e.target.value , index : read.currentQuestion - 1 }))
                write.loading = true
                posthog.capture('question_answered', {
                    invitation_id: read.id,
                    question_index: read.currentQuestion - 1,
                    question_type: questionData.questionType,
                    total_questions: read.totalQuestions,
                });
            }, 600);
        }
    }



    const RenderQuestions = React.useCallback(() => {
        return (
            <form className="w-full" onChange={handleAnswer}>
                <ul className="grid w-full gap-3 sm:gap-4 md:grid-cols-2">

                    {
                        questionData.answers.map((answer, index) => { // speaking and writing don't have [] of answers.
                            return (
                                <li className='relative min-w-0' key={index}>
                                    <input disabled={selected ? true : false} type="radio" id={index} name="answers" value={index + 1} className="hidden peer" required />
                                    <label htmlFor={index} className="inline-flex min-h-[64px] w-full cursor-pointer items-center justify-center rounded-2xl border border-slate-200 bg-white p-4 pl-8 text-slate-600 shadow-sm transition-colors hover:border-blue-200 hover:bg-blue-50 peer-checked:border-blue-600 peer-checked:bg-blue-50 peer-checked:text-green-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300 dark:peer-checked:text-blue-500">
                                        <div className="block min-w-0">
                                            <div style={{ overflowWrap: 'anywhere' }} className="question-answer-text w-full overflow-auto text-sm font-semibold leading-6 sm:text-base">{answer}</div>
                                        </div>
                                        {selected - 1 === index && <>✅</>}
                                    </label>
                                    <div className='absolute left-2 top-2 text-xs font-black text-slate-400'> {choices[index]} </div>
                                </li>
                            )
                        })
                    }
                </ul>
            </form>
        )


    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // console.log(read.tabControl)



    return (

        <div className='question-stage w-full'>
            <div className="relative w-full max-w-5xl">
                {read.loading && <LoadingOverCard />}
                {/* {console.log(read.instruction[type] , read.instruction , type , read.currentQuestionType)} */}
                {read.instruction[type] && <div ref={contentRef} className='question-card flex w-full flex-col gap-4 rounded-3xl border border-white/70 bg-white/95 p-4 shadow-2xl shadow-slate-900/10 backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800 sm:p-5 md:p-6' >
                    {questionData.questionType === 'listening' && <Listening dataPath={questionData.dataPath} />}
                    <p className={`question-copy overflow-y-auto rounded-2xl bg-slate-50 p-4 text-left text-lg font-extrabold leading-7 tracking-tight text-slate-950 dark:text-white sm:text-xl md:text-2xl md:leading-9`}>
                        {questionData.question}
                    </p>
                    {questionData.questionType === 'writing' && <Writing />}
                    {questionData.questionType === 'speaking' && <Speaking />}
                    {questionData.answers.length !== 0 && <RenderQuestions />}
                    { read.tabControl === 1 && <NewModal type={'tabCTRL'} />}
                </div>}
            </div>
        </div>


    );
}

export default SingleQ;










